import styled from "styled-components";

import "../../GlobalStyles/Font.css";

export const ContainerSignUpPage = styled.div`
  max-width: 100%;
  padding: 16px 20px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 30px;
`;

export const TitleSignUpPage = styled.h1`
  font-size: 20px;
  font-family: "Exo2 Light";
  line-height: 1.2;
  text-align: center;

  @media (min-width: 744px) {
    font-size: 24px;
    line-height: 1.2;
  }

  @media (min-width: 1024px) {
    font-size: 32px;
    line-height: 1.18;
  }

  @media (min-width: 1440px) {
    font-size: 36px;
    line-height: 1.19;
  }
`;

export const TitleSignInAccount = styled.h1`
  text-align: center;
  font-size: 24px;
  line-height: 1.2;
  font-family: "Exo2 Light";
`;

export const ButtonSignInAccount = styled.button`
  font-size: 24px;
  line-height: 1.2;
  font-family: "Exo2 Medium";
  color: #1a50c6;
  cursor: pointer;
`;
